<ng-container *ngIf="(publicationAccessService.publication$)|async as publication">

  <ng-container *ngIf="!publication?.pubUuid">
    <div class="mt-10 flex justify-center items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-gray-700" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <span class="text-xl font-semibold">No publication passed to the preview...</span>
    </div>
  </ng-container>

  <ng-container *ngIf="publication?.pubUuid">

    <ng-container *ngIf="!(surveyViewerService.haveRules$|async)?.ext?.length">
      <div class="mt-10 flex justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-gray-700" fill="none" viewBox="0 0 24 24"
             stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span class="text-xl font-semibold">No rules based on ext.</span>
      </div>
    </ng-container>

    <div *ngFor="let anExt of (surveyViewerService.haveRules$|async)?.ext"
         class="flex flex-col w-full py-4 px-5 mb-2 rounded-lg bg-gray-200 dark:bg-gray-800">
      <div class="flex font-bold">{{ anExt }}</div>
      <ng-container>
        <div class="flex flex-auto flex-col w-full mt-2">
          <ng-container [appExt]="publication.extProfilsNeeded.extDef[anExt]"></ng-container>
        </div>
      </ng-container>
    </div>

  </ng-container>

</ng-container>
